<template>
  <v-layout row>
    <v-flex md12 sm12>
      <v-form ref="form2">
        <v-card color="#FFF" class="black--text">
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 pa-3>
                <span class="headline">Proposta</span>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  v-model="average_consumption"
                  prefix="R$"
                  label="Média de Consumo"
                  return-masked-value
                  mask="########"
                  required
                  style="font-color: #fff"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-list two-line subheader>
                  <v-subheader class="font-weight-bold"
                    >Dados Ambientais (Ano)</v-subheader
                  >

                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>nature</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Arvores Plantadas</v-list-tile-title>
                      <v-list-tile-sub-title>{{ trees }}</v-list-tile-sub-title>
                    </v-list-tile-content>

                    <!-- <v-list-tile-action>
                                        <v-btn icon ripple>
                                            <v-icon color="grey lighten-1">info</v-icon>
                                        </v-btn>
                                        </v-list-tile-action> -->
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>eco</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title
                        >Redução de toneladas de c02</v-list-tile-title
                      >
                      <v-list-tile-sub-title>{{ co2 }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>local_gas_station</v-icon>
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>Barris de petroleo</v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        barris
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-subheader class="font-weight-bold"
                    >Dados Economicos</v-subheader
                  >
                  <v-list-tile pa-0>
                    <v-list-tile-content>
                      <v-list-tile-title
                        >Creditos Previstos
                        <span class="caption">(R$) </span></v-list-tile-title
                      >
                      <!-- <v-list-tile-sub-title>R$ {{economyBoleto.toFixed(2).replace('.', ',')}} por mês</v-list-tile-sub-title> -->
                    </v-list-tile-content>
                    <v-list-tile-action class="font-weight-bold">
                      R$ {{ Number(credits).toFixed(2).replace(".", ",") }}
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-list-tile>
                    <!-- <v-list-tile-avatar>
                                        <v-icon>eco</v-icon>
                                        </v-list-tile-avatar> -->

                    <v-list-tile-content>
                      <v-list-tile-title
                        >Economia Boleto e Pix
                        <span class="caption">(10%)</span></v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >R$ {{ economyBoleto.toFixed(2).replace(".", ",") }} por
                        mês</v-list-tile-sub-title
                      >
                    </v-list-tile-content>

                    <v-list-tile-action class="font-weight-bold">
                      R$
                      {{
                        Number(economyBoleto * 12)
                          .toFixed(2)
                          .replace(".", ",")
                      }}
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-list-tile>
                    <!-- <v-list-tile-avatar>
                                        <v-icon>eco</v-icon>
                                        </v-list-tile-avatar> -->

                    <v-list-tile-content>
                      <v-list-tile-title
                        >Economia Cartão
                        <span class="caption">(15%)</span></v-list-tile-title
                      >
                      <v-list-tile-sub-title
                        >R$ {{ economyCartao.toFixed(2).replace(".", ",") }} por
                        mês</v-list-tile-sub-title
                      >
                    </v-list-tile-content>

                    <v-list-tile-action class="font-weight-bold">
                      R$
                      {{
                        Number(economyCartao * 12)
                          .toFixed(2)
                          .replace(".", ",")
                      }}
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: ["average"],
  created() {
    this.average_consumption = this.average;
  },
  data: () => ({
    average_consumption: 0,
  }),
  computed: {
    co2() {
      let co2gperkWh = Number(this.average_consumption) * 12 * 86.7654;
      let co2ton = co2gperkWh / 1000000;
      return co2ton.toFixed(2).replace(".", ",");
    },
    trees() {
      let co2gperkWh = Number(this.average_consumption) * 12 * 86.7654;
      let co2ton = co2gperkWh / 1000000;
      // 0.060 metric ton CO2 per urban tree planted
      let trees = co2ton / 0.06;
      return trees.toFixed(2).replace(".", ",");
    },
    barris() {
      let co2gperkWh = Number(this.average_consumption) * 12 * 86.7654;
      let co2ton = co2gperkWh / 1000000;

      // 0.43 metric tons CO2/barrel
      let oilBarrel = co2ton / 0.43;
      return oilBarrel.toFixed(2).replace(".", ",");
    },
    credits() {
      if (this.average_consumption && this.average_consumption > 0) {
        return Number(this.average_consumption * (1 - 0.09) - 50);
      } else {
        return 0;
      }
    },
    economyBoleto() {
      if (this.average_consumption && this.average_consumption > 0) {
        return Number((this.average_consumption * (1 - 0.09) - 50) * 0.1);
      } else {
        return 0;
      }
    },
    economyCartao() {
      if (this.average_consumption && this.average_consumption > 0) {
        return Number((this.average_consumption * (1 - 0.09) - 50) * 0.15);
      } else {
        return 0;
      }
    },
  },
};
</script>
